import { userInteraction, handleError, MessageBoxButton } from "@eusoft/webapp-framework";
import { fullUri } from "@eusoft/webapp-framework/helpers/Utils";
import { formatText, formatCurrency } from "@eusoft/webapp-ui";
import { paymentService } from "../abstraction/IPaymentService";
import { PaymentCardStatus, PaymentCardType, type Guid, type ICardListView } from "../entities/Commands";
import { formatMarkDown } from "../helpers/Format";
import { context } from "../services/Context";
import { executeAsync } from "../services/DataService";



export async function writeCardWalletAsync(walletId: Guid) {

    while (true) {

        const res = await handleError(() => paymentService.writeCardAsync({
            uri: fullUri("/wallet/" + walletId),
            message: formatText("msg-wait-for-card-write") as string
        }));

        if (res)
            return true;

        const action = await userInteraction.messageBoxAsync(
            formatText("card-write-error"), "error", MessageBoxButton.RetryCancel);

        if (action == MessageBoxButton.Cancel)
            return;
    }

}


export async function blockCardAsync(item: ICardListView) {

    if (!await userInteraction.confirmAsync(formatText("msg-confirm-block"), "confirm"))
        return;

    const res = await executeAsync("BlockCard", {
        cardId: item.id,
        salePointId: context.salePoint?.id
    });

    if (res?.blockCode)
        item.status = PaymentCardStatus.Blocked;

    return true;
}


export async function unblockCardAsync(item: ICardListView) {

    const res = await executeAsync("UnblockCard", {
        cardId: item.id,
        salePointId: context.salePoint?.id
    });

    if (res) {
        item.status = PaymentCardStatus.Active;
        userInteraction.messageAsync(formatText("msg-card-unblocked"), "success", 3000);
    }
    return res;
}

export async function replaceCardAsync(item: ICardListView) {

    if (!await userInteraction.confirmAsync(formatText("msg-confirm-replace"), "confirm"))
        return;

    const auth = await executeAsync("AuthorizePayment", {
        amount: 0,
    });

    if (!auth)
        return;

    const newCard = await handleError(() => paymentService.readCardAsync({
        message: formatText("msg-wait-for-replace-card") as string,
        payToken: auth
    }));

    if (!newCard)
        return;

    const newCardInfo = await executeAsync("GetCardInfo", {
        cardCode: newCard.code,
    });

    if (!newCardInfo)
        return;

    if (newCardInfo.balance > 0) {
        userInteraction.messageAsync(formatMarkDown("msg-card-has-balance", formatCurrency(newCardInfo.balance)), "error", 4000);
        return;
    }

    const walletId = await executeAsync("ReplaceCard", {
        oldCardId: item.id,
        newCardToken: newCard.payAuth,
        salePointId: context.salePoint?.id,
        allowResetNew: true
    });

    if (!walletId)
        return;

    if (newCard.type == PaymentCardType.Nfc)
        await writeCardWalletAsync(walletId);

    userInteraction.messageAsync(formatText("msg-card-replaced", newCard.code), "success", 4000);

    return false;
}
